import React from 'react';

export const FormContainer = ({ children }: { children: React.ReactNode }) => (
  <div className="grid grid-cols-3 gap-8">{children}</div>
);

export default FormContainer;
